import React, { useEffect } from 'react';
import {makeStyles} from "@material-ui/core/styles/index";
import Typography from "@material-ui/core/es/Typography/Typography";
import WarmUpRequest from "./WarmUpRequest";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            position: 'relative',
            backgroundColor: '#3f51b4',
            width: '100%',
            height: 100,
            marginBottom: 10,
            '& p': {
                color: '#fff',
                display: 'inline'
            }
        },
        leftPart: {
            paddingTop: 6,
            marginLeft: 10
        },
        codeLabel: {
            fontSize: '1.5rem',
            fontWeight: 'bold',
        },
        codeValue: {
            fontSize: '2.1rem',
            marginLeft: 10,
            fontWeight: 'bold',
        },
        divider: {
            width: 225,
            height: 1,
            borderTop: '1px solid #fff',
        },
        description: {
            marginTop: 4,
            '& p': {
                fontWeight: 'bold',
            }
        },
        rightPart: {
            position: 'absolute',
            right: 5,
            top: 15
        },
        vehicleImage: {
            display: 'inline-block',
            width: 60,
            marginRight: 10,
            '& img': {
                borderRadius: 2
            }
        },
        endsIn: {
            fontSize: '0.7rem'
        },
        clock: {
            fontSize: '0.8rem',
            marginLeft: 5
        }
    }
});

let WarmUp__interval = null;
let WarmUp__secondsLeft = null;

export default function WarmUp(props) {

    const classes = useStyles();

    const [data, setData] = React.useState();
    const [secondsLeft, setSecondsLeft] = React.useState();

    const [hours, setHours] = React.useState(36);

    const [minutes, setMinutes] = React.useState(12);
    const [seconds, setSeconds] = React.useState(45);

    const isMobile = props.isMobile;

    const handleData = (data) => {
        setData(data);
        if (!WarmUp__secondsLeft && data && data.expiresInSeconds) {
            WarmUp__secondsLeft = data.expiresInSeconds;
        }
    };

    const handleError = (error) => {
        //setError(error);
    };

    const updateCounter = () => {
        const newSecondsLeft = Math.max(0, WarmUp__secondsLeft - 1);
        WarmUp__secondsLeft = newSecondsLeft;
        setSeconds(Math.floor( (newSecondsLeft) % 60 ));
        setMinutes(Math.floor( (newSecondsLeft/60) % 60 ));
        setHours(Math.floor( (newSecondsLeft/(60*60)) ));
    }

    useEffect(() => {
        if (data && WarmUp__secondsLeft) {
            clearInterval(WarmUp__interval);
            WarmUp__interval = setInterval(updateCounter, 1000);
        }
    });

    const width = props.screenWidth;
    const zoom = Math.min(1, width/414);

    return (
        !data ? <WarmUpRequest onData={handleData} onError={handleError}/> :
        <div className={classes.root} style={zoom !== 1 ? {zoom: zoom} : null}>
            <div className={classes.leftPart}>
                <Typography className={classes.codeLabel}>Code</Typography>
                <Typography className={classes.codeValue}>{data.code}</Typography>
                <div className={classes.divider}></div>
                <div className={classes.description}>
                    <Typography>Instant ${new Intl.NumberFormat().format(data.discountMinorUnits/100)} off any vehicle</Typography>
                </div>
            </div>

            <div className={classes.rightPart}>
                <div className={classes.vehicles}>
                    {data.images.map(image => {
                        return <div className={classes.vehicleImage}><a href={image.url}>
                            <img src={image.image} width="100%"/>
                        </a></div>
                    })}
                </div>
                <div className={classes.counter}>
                    <Typography className={classes.endsIn}>ENDS IN</Typography>
                    <Typography className={classes.clock}>{hours}H {minutes}M {seconds}S</Typography>
                </div>
            </div>
        </div>
    );
}
